import { render, staticRenderFns } from "./page-users.vue?vue&type=template&id=14c57310&"
import script from "./page-users.vue?vue&type=script&lang=ts&"
export * from "./page-users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports